import { type ISchoolPayload } from "../../map-panel-context";

const DRIVE_BASE = "/panel/drive";
const DRIVE_SCHOOLS_PATH = "/Schools";

function primaryLevelSegment(payload: ISchoolPayload): string {
  const first = payload.schoolLevelIds?.[0];
  return first ?? "unassigned";
}

export function buildSchoolDriveHref(payload: ISchoolPayload | null): string {
  if (!payload?.schoolId) return DRIVE_BASE;

  const levelSeg = primaryLevelSegment(payload);

  if (payload.schoolDriveId) {
    const path = `${DRIVE_SCHOOLS_PATH}/${levelSeg}/${payload.schoolDriveId}`;
    return `${DRIVE_BASE}?path=${encodeURIComponent(path)}`;
  }

  if (payload.schoolLevelIds?.length) {
    const path = `${DRIVE_SCHOOLS_PATH}/${levelSeg}/${payload.schoolId}`;
    return `${DRIVE_BASE}?path=${encodeURIComponent(path)}`;
  }

  return `${DRIVE_BASE}?path=${encodeURIComponent(DRIVE_SCHOOLS_PATH)}`;
}
